/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-08-01_front-back-esm.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-08-01_front-back-esm.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-08-01_front-back-esm.mdx';

const metadata = {
  slug: "2020-08-01_front-back-esm",
  title: "Front & Back ESM",
  author: "Christian Battaglia",
  description: "Exploring the dream of writing frontend and backend code in one fell swoop with native ESM — Vite for the browser, native Node.js for the server, and the three pieces needed to make it work.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-08-01T00:00:00.000Z",
  
  readTime: "1 min read",
  tags: ["ESM","Vite","Node.js","TypeScript","SSR","frontend","backend","isomorphic"],
};

export const Route = createFileRoute('/blog/posts/2020-08-01_front-back-esm')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-08-01_front-back-esm',
    image: '/og/blog/2020-08-01_front-back-esm.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
